import { useState, useEffect } from "react";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
} from "recharts";

export default function TrafficChart() {
  let [data, setData] = useState([]);
  useEffect(() => {
    fetch("https://router.icfelix.workers.dev/traffic-change")
      .then((response) => {
        if (!response.ok) {
          throw new Error("HTTP error " + response.status);
        }
        return response.json();
      })
      .then((json) => {
        // Clean JSON data.
        let vals = [];
        let httpValues = json.data.http;
        let totalValues = json.data.total;
        Object.keys(json.data.http).forEach((key) => {
          vals.push({
            name: key,
            http: httpValues[key],
            total: totalValues[key],
          });
        });
        setData(vals);
      });
  }, []);

  const CustomTooltip = ({ active, payload, label }) => {
    if (active && payload && payload.length) {
      let payloadDate = new Date(label).toLocaleString();
      return (
        <div className="tooltip">
          <p className="label">{`${payloadDate} : ${payload[0].value}`}</p>
          <p className="label">{`${payloadDate} : ${payload[1].value}`}</p>
          <p className="intro">
            Percentage change in internet traffic on {payloadDate}.
          </p>
        </div>
      );
    }

    return null;
  };

  return (
    <LineChart
      width={800}
      height={300}
      data={data}
      margin={{
        top: 5,
        right: 30,
        left: 20,
        bottom: 5,
      }}
    >
      <CartesianGrid strokeDasharray="3 3" />
      <XAxis dataKey="name" interval="preserveStartEnd" minTickGap={8} />
      <YAxis />
      <Tooltip content={<CustomTooltip />} />
      <Legend />
      <Line type="monotone" dataKey="http" stroke="#8884d8" dot={false} />
      <Line type="monotone" dataKey="total" stroke="#82ca9d" dot={false} />
    </LineChart>
  );
}
